//
//
//
//
//
//
//
//
//
//

import PageHeader from '../../components/header'
import PageFooter from '../../components/footer'
export default {
  name: 'app',
  components: {
    PageHeader,
    PageFooter
  },
  beforeMount () {
    let availWidth = window.screen.availWidth
    if (availWidth >= 1100) {
      // 宽度大于等于1200时,跳转到pc地址
      window.location.href = 'http://www.quanruntong.com/'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.vue